<p-card [class]="class()" [styleClass]="styleClass()">
  <ng-template #header *ngIf="hasHeaderRow()">
    <ng-container *ngIf="cardHeader(); else builtInHeader">
      <ng-container *ngTemplateOutlet="cardHeader()!"></ng-container>
    </ng-container>

    <ng-template #builtInHeader>
      <div class="pc-header">
        <span class="pc-header__text">
          <span class="pc-header__title" *ngIf="headerText()">{{ headerText() }}</span>
          <span class="pc-header__subheader" *ngIf="subheaderText()">{{ subheaderText() }}</span>
        </span>
      </div>
    </ng-template>
  </ng-template>

  <div class="pc-body">
    <div class="pc-body__inner">
      <ng-container *ngIf="cardContent(); else defaultContent">
        <ng-container *ngTemplateOutlet="cardContent()!"></ng-container>
      </ng-container>
      <ng-template #defaultContent>
        <ng-content></ng-content>
      </ng-template>
    </div>
  </div>

  <ng-template #footer *ngIf="cardFooter()">
    <ng-container *ngTemplateOutlet="cardFooter()!"></ng-container>
  </ng-template>
</p-card>
